import React, { useEffect, useRef, useState } from 'react';

const GoogleTranslate = () => {
  const googleTranslateElementRef = useRef(null);

  useEffect(() => {
    const loadGoogleTranslateScript = () => {
      if (!document.querySelector('script[src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]')) {
        const script = document.createElement('script');
        script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
        script.async = true;
        document.body.appendChild(script);
      }

      window.googleTranslateElementInit = () => {
        if (window.google) {
          new window.google.translate.TranslateElement(
            {
              pageLanguage: 'en', // Set default page language to English
              includedLanguages: 'es,en', // Specify included languages (Spanish and English)
              layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE // Use the layout that shows the dropdown
            },
            googleTranslateElementRef.current
          );

          // Modify the Google Translate element after it's initialized
          modifyGoogleTranslate();
        }
      };
    };

    const modifyGoogleTranslate = () => {
      const interval = setInterval(() => {
        const translateElement = googleTranslateElementRef.current?.querySelector('.goog-te-gadget-simple');
        if (translateElement) {
          translateElement.querySelector('span[aria-hidden="true"]')?.remove(); // Remove unnecessary span
          translateElement.querySelector('span[style*="border-left: 1px solid rgb(187, 187, 187);"]')?.remove(); // Remove border
          translateElement.classList.add('form-select'); // Add custom class
          
          // Hide the default dropdown
          const dropdown = translateElement.querySelector('select');
          if (dropdown) {
            dropdown.style.display = 'none';
          }
          
          clearInterval(interval);
        }
      }, 100);
    };

    loadGoogleTranslateScript();

    return () => {
      const scriptElement = document.querySelector('script[src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]');
      if (scriptElement) {
        document.body.removeChild(scriptElement);
      }
    };
  }, []);

  return (
    <>      
      <div id="google_translate_element" ref={googleTranslateElementRef}></div>
    </>
  );
};

export default GoogleTranslate;
